const baseUrl = process.env.REACT_APP_API_BASE_URL;
const API = {
  MDSearch: `${baseUrl}/api/materialdeclarations`,
  MDDetail: `${baseUrl}/api/materialdeclaration`,
  MDMaterialInformation: `${baseUrl}/api/MaterialDeclaration/mdmaterials`,
  MDRelatedDocuments: `${baseUrl}/api/materialdeclaration/mdrelateddocuments/`,
  MasterMaterialInformation: `${baseUrl}/api/materialdeclaration/mastermaterials`,
  MDRemarksGet: `${baseUrl}/api/materialdeclaration/remarks`,
  CompanyList: `${baseUrl}/api/SMD/Companies`,
  SDocCompanyList: `${baseUrl}/api/SMD/CompaniesAndAttachments`,
  GDCompanyList: `${baseUrl}/api/GD/CompaniesAndAttachments`,

  //MD New Item Post method API'S
  MDPostAPI: `${baseUrl}/api/materialdeclaration`,
  MIPostAPI: `${baseUrl}/api/materialdeclaration/mdmaterials`,
  RDPostAPI: `${baseUrl}/api/materialdeclaration/mdrelateddocuments`,
  RemarkPostAPI: `${baseUrl}/api/materialdeclaration/mdremarks`,

  //MD Delete
  MDDelete: `${baseUrl}/api/materialdeclaration`,


  //Md Sd Upload
  MDSDShiplist: `${baseUrl}/api/MdocSdoc/ShipList`,
  MDSDPOlist: `${baseUrl}/api/MdocSdoc/PoList`,
  MDSDExceptions: `${baseUrl}/api/MdocSdoc/Exceptions`,

  //MD item update

  MDUpdateAPI: `${baseUrl}/api/materialdeclaration`,
  MIUpdateAPI: `${baseUrl}/api/materialdeclaration/mdmaterials`,
  RDUpdateAPI: `${baseUrl}/api/materialdeclaration/mdrelateddocuments`,

  //SMD Search

  SMDSearch: `${baseUrl}/api/suppliermaterialdeclarations`,
  SMDPostAPI: `${baseUrl}/api/suppliermaterialdeclaration`,

  //GD Search

  GDSearch: `${baseUrl}/api/genericdeclaration`,
  GDPostAPI: `${baseUrl}/api/genericdeclaration`,

  //attachment upload

  AttachmentAPI: `${baseUrl}/api/attachment/upload`,
  AttachmentsAPI: `${baseUrl}/api/attachments/upload`,
  DownloadAttachmentAPI: `${baseUrl}/api/attachment/download`,
  DeleteAttachmentAPI: `${baseUrl}/api/attachment/delete`,
  DeleteMDocSdocAttachments: `${baseUrl}/api/polineitem/attachments/delete`,
  PostDocumentAPI: `${baseUrl}/api/Ship/LocationDocument`,
  getDocumentAPI: `${baseUrl}/api/ship/LocationDocuments`,

  //SMD delete

  SMDDelete: `${baseUrl}/api/suppliermaterialdeclaration/`,

  //GD delete

  GDDelete: `${baseUrl}/api/genericdeclaration/`,

  //reports API

  ReportAPI: `${baseUrl}/api/reports`,
  ExportReportAPI: `${baseUrl}/api/report/download`,

  //Users API
  UserAPI: `${baseUrl}/api/user`,
  getUser: `${baseUrl}/api/users`,

  //login user Authentication

  AuthenticateUser: `${baseUrl}/api/login`,
  ADUsers: `${baseUrl}/api/adusers`,
  UserRole: `${baseUrl}/api/User/role`,

  // Ship View
  ShipDetail: `${baseUrl}/api/ship`,
  PendingTask: `${baseUrl}/api/ship/pendingtasks`,
  PendingTaskLineItem: `${baseUrl}/api/ship/pendingtasks/polineItems`,
  IHMFullManual: `${baseUrl}/api/ship/ihmpart`,
  RevisionHistory: `${baseUrl}/api/ship/revisionhistory`,
  /* RevisionDelete:`${baseUrl}/api/revisionhistory`,  */
  // Certificates: `${baseUrl}/api/ship/certificate`,
  POSearch: `${baseUrl}/api/ship/validatedposearch`,
  putPendingTask: `${baseUrl}/api/ship/pendingtask`,
  bulkUpdatePendingTask: `${baseUrl}/api/ship/bulkpendingtasks`,
  GetOtherTask: `${baseUrl}/api/Ship/tasks`,
  PutOtherTask: `${baseUrl}/api/Ship/task`,

  //Dashboard
  clientNames: `${baseUrl}/api/client/names`,

  // Client Dashboard
  ClientShipCount: `${baseUrl}/api/totalships`,
  ClientShipSearch: `${baseUrl}/api/shipsearch`,
  ConsultantCLients: `${baseUrl}/api/specialAccess`,

  //MMPl Dashboard
  MMPLShipCount: `${baseUrl}/api/mmpl/totalships`,
  MMPLShipSearch: `${baseUrl}/api/mmpl/posearch`,
  CollectMDocSDocAPI: `${baseUrl}/api/mmpl/podoccollect`,
  GetInventory: `${baseUrl}/api/inventory`,
  PostInventory: `${baseUrl}/api/inventory`,
  PostAddInventory: `${baseUrl}/api/addinventory`,
  PutInventory: `${baseUrl}/api/inventory`,
  GetPaintCoating: `${baseUrl}/api/inventory/paint`,
  GetEquipmentMachinery: `${baseUrl}/api/inventory/equipment`,
  GetStructureHull: `${baseUrl}/api/inventory/structure`,
  GetStore: `${baseUrl}/api/inventory/stores`,
  InventoryDocument: `${baseUrl}/api/invetory/data/excel`,
  DeleteRevisionDocument: `${baseUrl}/api/revision/attachment/remove`,
  GetClients: `${baseUrl}/api/clientsAndPos`,
  //GetShips: `${baseUrl}/api/shipsAndPos`,

  //PO View
  PODetail: `${baseUrl}/api/mmpl/po`,
  LineItems: `${baseUrl}/api/ship/polineitems`,
  PoConfirmation: `${baseUrl}/api/mmpl/poconfirmation`,
  PoConfirmationAll: `${baseUrl}/api/mmpl/poconfirmation/all`,
  CollectMDLineItems: `${baseUrl}/api/mmpl/collectmd/lineitems`,
  AddAll: `${baseUrl}/api/mmpl/po/lineitem/add/povalidation`,
  PCHM: `${baseUrl}/api/mmpl/po/confirmation`,
  ShortClosed: `${baseUrl}/api/po/shortClosed`,
  MailMDocSDoc: `${baseUrl}/api/po/reminder/mail`,
  HoldMail: `${baseUrl}/api/po/reminder/hold`,
  ShipPO: `${baseUrl}​/api/shipsAndPos`,
  poUpload: `${baseUrl}/api/PO/Excel`,
  RevertPo: `${baseUrl}​/api/ship/RestorePolineitems?PoId=`,
  ClassFlagData: `${baseUrl}/api/Ship/ClassFlagData?type=`,

  //Exception management
  Exception: `${baseUrl}/api/manage/exception`,

  //Po Sync Exception
  POSyncException: `${baseUrl}/api/poexception`,


  //Keyword management
  Keywordlist: `${baseUrl}/api/manage/keywords`,
  postKeyword: `${baseUrl}/api/manage/keyword`,

  //Exist Keyword mangement
  Existkeywordlist: `${baseUrl}/api/manage/lineitems`,
  DeleteExistkeyword: `${baseUrl}/api/manage/lineitem`,

  //Material declaration
  GetMaterialDeclaration: `${baseUrl}/api/materialdeclaration/v2`,
  PostMaterialDeclaration: `${baseUrl}/api/materialdeclaration/v2`,
  BulkUpdateMDSDoc: `${baseUrl}/api/materialdeclaration/v2/All`,
  PutMaterialDeclaration: `${baseUrl}/api/materialdeclaration/v2`,
  DeleteMaterialDeclaration: `${baseUrl}/api/materialdeclaration/v2`,
  PostMD: `${baseUrl}/api/ihmmaterialdeclaration`,
  PostMDRemarks: `${baseUrl}/api/ihmmdremarks`,
  PostMDMAterials: `${baseUrl}/api/ihmmdmaterials`,

  //Staff management
  Stafflist: `${baseUrl}/api/manage/staffs`,
  PostStaff: `${baseUrl}/api/manage/staff`,

  //Client management
  Clientlist: `${baseUrl}/api/manage/client`,
  postClient: `${baseUrl}/api/manage/clients`,
  ClientUser: `${baseUrl}/api/manage/clientuser`,
  specialAcces: `${baseUrl}/api/manage/specialAccessUser`,
  SpecialClient: `${baseUrl}/api/manage/specialAccess`,
  SpecialClientList: `${baseUrl}/api/specialclientlist`,

  //Client user management
  PutClientUsers: `${baseUrl}/api/manage/masterClientuser`,
  GetClientUserArray: `${baseUrl}/api/ClientUsersListGet`,
  GetAddedClientUsersList: `${baseUrl}/api/manage/clientUserDetails`,

  //Special access
  PostSpecialAccess: `${baseUrl}/api/manage/specialAccessUser`,
  PutSpecialAccess: `${baseUrl}/api/manage/specialAccessUser`,


  //Ship management
  Shiplist: `${baseUrl}/api/manage/ships`,
  postShip: `${baseUrl}/api/manage/ship`,
  pullDate: `${baseUrl}/api/ship/po/pulldate`,
  GetLRForm: `${baseUrl}/api/Ship/LR`,
  GetPersons: `${baseUrl}/api/Ship/inventory/persons`,
  LRFormPDF: `${baseUrl}/api/Ship/LR/PDF`,

  //Certificates
  Certificates: `${baseUrl}/api/certificates`,

  //helpers
  shipNames: `${baseUrl}/api/ship/names`,
  companyNames: `${baseUrl}/api/clientlist`,
  companyUserNames: `${baseUrl}/api/clientuserslist`,

  //po export

  POExport: `${baseUrl}/api/PO/Export`,
  POExportExcel: `${baseUrl}/api/PO/Export/Excel`,
  ShipExportExcel: `${baseUrl}/api/ships/MDandSDoc/Excel`,
  POExportMDAndSDoc: `${baseUrl}/api/Ship/MdsAndSdocs/zip`,

  //Six month review
  GetSixMonthReview: `${baseUrl}/api/Ship/Review`,
  GetSixMonthReviews: `${baseUrl}/api/Ship/Reviews`,
  PostSixMonthReview: `${baseUrl}/api/Ship/Review`,

  //Exist user check
  userExist: `${baseUrl}/api/User/Exist`,

  // IdentityServer
  password: `${baseUrl}/api/ChangePassword`,
  resetpassword: `${baseUrl}/api/ResetPassword`,

  // Inventory
  UploadRevision: `${baseUrl}/api/mannual/attachment`,

  //LRUpload
  UploadLRFrom: `${baseUrl}/api/attachment/LRUpdate`,

  //ShipDocument
  GetShipDocument: `${baseUrl}/api/Ship/documents`,
  ShipDocument: `${baseUrl}/api/Ship/document`,

  // Te Forms
  GetTEForms: `${baseUrl}/api/Ship/TeForm`,

  // Class flag circulars
  GetClassFlagCirculars: `${baseUrl}/api/Ship/ClassFlagCirculars`,

  // Teams
  GetTeamsOfUser: `${baseUrl}/api/mmpl/teams`,

  // KPI Dashboard api
  GetKPIData: `${baseUrl}/api/kpi`,

  // User api
  GetAllUsersData: `${baseUrl}/api/mmpls`,

  // Teams
  // CreateTeams: `${baseUrl}/api/mmpl/team`,
  CreateTeams: `${baseUrl}/api/mmpl/v2/team`,
  GetUserTeams: `${baseUrl}/api/mmpl/teammates`,

  //Management
  FleetManager: `${baseUrl}/api/fleetmanager`,
  TechnicalSuperIntendents: `${baseUrl}/api/technicalsuperintendents`,
  TechnicalExecutive: `${baseUrl}/api/technicalexecutive`,

  // PO Sync Dashboard APIs
  PoSyncClients: `${baseUrl}/api/po-sync-dashboard/clients`,
  PoSyncShips: `${baseUrl}/api/po-sync-dashboard/ships`,
  PoSyncHistory: `${baseUrl}/api/po-sync-history`,

};
export default API;
